module.exports = __webpack_public_path__ + "img/in.3a53c204.svg";